
import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://jsdptopnqwmjlqxncfpb.supabase.co';
export const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpzZHB0b3BucXdtamxxeG5jZnBiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg2OTE4MzIsImV4cCI6MjA4NDI2NzgzMn0.wCKe3xX4cP4y2sDKXUUOKk18tjdYrbfn7pErvi9olrw';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
